angular.module 'zc.projects'

.directive 'campaignDevice', ($translate) ->
  directive =
    restrict: "A"
    require: '?ngModel'
    scope: {
      campaign: "=ngModel"
    }
    link: (scope, element, attrs) ->
      $(element).addClass("label")

      deviceClass = ""
      txt = ""
      switch scope.campaign.campaign_device
        when "pc"
          txt = $translate.instant('projectsCampaigns.directives.labelCampaignDevice.pc')
          deviceClass = "device-desktop"
        when "sp"
          txt = $translate.instant('projectsCampaigns.directives.labelCampaignDevice.sp')
          deviceClass = "device-mobile"
        when "iphone"
          txt = $translate.instant('projectsCampaigns.directives.labelCampaignDevice.iphone')
          deviceClass = "device-iphone"
        when "devicefree"
          txt = $translate.instant('projectsCampaigns.directives.labelCampaignDevice.devicefree')
          deviceClass = "device-devicefree"

      $(element).addClass(deviceClass)
      $(element).html(txt)

  directive



// WEBPACK FOOTER //
// ../enterprise/src/zenclerk_modules/projects.campaigns/directives/label_campaign_device.js.coffee